/** Shared constants for the Care Support Leaders pages. */

/**
 * Maximum length of a leader biography.
 *
 * Enforced on both entry points that write the field — the Add Leader wizard
 * (`Wizard/AddLeaderWizard.tsx`) and the Edit drawer (`[LeadersDetails]/Tabs/EditTab.tsx`).
 * Bios already stored above this length are left untouched until someone edits them.
 */
export const LEADER_BIO_MAX_LENGTH = 20;
